// Feature flag constants
export const FEATURES = Object.freeze({
  ALTERNATIVE_ORDER_TYPE_NAMING: {
    name: 'alternative_order_type_naming',
    defaultValue: false,
  },
  APPOINTMENT_CHANGE_REASON_CODES: {
    name: 'appointment_change_reason_codes',
    defaultValue: [],
  },
  ALTERNATE_REFERENCE_NUMBER_MAP: {
    name: 'alternate_reference_number_map',
    defaultValue: false,
  },
  AVAILABLE_FILTERING_FIELDS: {
    name: 'available_filtering_fields',
    defaultValue: false,
  },
  BUNDLE_ORDER_TYPES_ENABLED: {
    name: 'bundle_order_types',
    defaultValue: false,
  },
  CAN_REASSIGN_DRIVER_ON_IN_PROGRESS_TRIP: {
    name: 'can_reassign_driver_on_in_progress_trip',
    defaultValue: false,
  },
  CAN_VIEW_CONTAINER_DASHBOARD: {
    name: 'can_view_container_dashboard',
    defaultValue: false,
  },
  CARRIER_REJECTION_REASONS: {
    name: 'carrier_rejection_reasons',
    defaultValue: false,
  },
  CARRIER_DOCUMENT_HANDLING: {
    name: 'carrier_document_handling',
    defaultValue: false,
  },
  CONTACT_SUPPORT: {
    name: 'contact_support',
    defaultValue: true,
  },
  DRIVER_TMS_ID: {
    name: 'driver_tms_id',
    defaultValue: false,
  },
  DROP_DELIVERY_TYPE: {
    name: 'drop_delivery_type',
    defaultValue: false,
  },
  EMAIL_NOTIFICATIONS: {
    name: 'email_notifications',
    defaultValue: true,
  },
  FORWARD_EDI_204_TO_CARRIER: {
    name: 'forward_edi_204_to_carrier',
    defaultValue: true,
  },
  FREIGHT_TYPE_LOCATION_BY_PLACE_ID: {
    name: 'freight_type_location_by_place_id',
    defaultValue: false,
  },
  HAZMAT_ORDERS: {
    name: 'hazmat_orders',
    defaultValue: false,
  },
  HIDE_RESERVATION_AND_RELEASE_NUMBER: {
    name: 'hide_reservation_number',
    defaultValue: true,
  },
  IMC_DELETE_DOCS: {
    name: 'imc_delete_documents',
    defaultValue: false,
  },
  IMC_VIEW_CARRIER_COLUMN: {
    name: 'imc_view_carrier_column',
    defaultValue: true,
  },
  IMC_VIEW_STARTABLE_COLUMN: {
    name: 'imc_view_startable_column',
    defaultValue: false,
  },
  INTERCOM: {
    name: 'intercom',
    defaultValue: false,
  },
  LANES: {
    name: 'lanes',
    defaultValue: true,
  },
  ORDERS_REQUIRE_APPOINTMENT: {
    name: 'orders_require_appointment',
    defaultValue: true,
  },
  LEGACY_EDI: {
    name: 'legacy_edi',
    defaultValue: true,
  },
  MARKETPLACE: {
    name: 'marketplace',
    defaultValue: true,
  },
  NETSUITE_INVOICING: {
    name: 'netsuite_invoicing',
    defaultValue: true,
  },
  // MV-3398: unlocks the marketplace Order Overview on ModalView. DrayNow does
  // not consult it — the overview has always been available there.
  ORDER_OVERVIEW: {
    name: 'order_overview',
    defaultValue: false,
  },
  REMOVE_DRIVER: {
    name: 'remove_driver',
    defaultValue: true,
  },
  SHOW_DISTANCE: {
    name: 'show_distance',
    defaultValue: true,
  },
  SHOW_TRIP_ID: {
    name: 'show_trip_id',
    defaultValue: true,
  },
  SHOW_REFERENCE_NUMBER: {
    name: 'show_reference_number',
    defaultValue: false,
  },
  SINGLE_MARKET: {
    name: 'single_market',
    defaultValue: false,
  },
  STREET_TURN_MANAGEMENT: {
    name: 'street_turn_management',
    defaultValue: true,
  },
  DRIVER_TRIP_ACCEPTANCE: {
    name: 'driver_trip_acceptance',
    defaultValue: false,
  },
  DRIVER_LATE_REASONS_REQUIRED: {
    name: 'driver_late_reasons_required',
    defaultValue: false,
  },
  SHARED_DRIVERS: {
    name: 'shared_drivers',
    defaultValue: false,
  },
})

export const VARIABLES = Object.freeze({
  TDIS_IMC_COMPANY_UID: 'cxjDUiwnBl',
})

export const TOAST_STATUS = {
  SUCCESS: 'success',
  POSITIVE: 'positive',
  ERROR: 'error',
  NEGATIVE: 'negative',
  INFO: 'info',
  WARNING: 'warning',
}

export const FREIGHT_TYPE_TO_AUDIENCE = Object.freeze({
  bmw: 'BMW',
  ford: 'Automotive',
  ['motor carrier']: 'Automotive',
})

export const SPECIALTY_FREIGHT_OPTIONS = Object.freeze([
  { key: 0, value: '', text: 'None' },
  { key: 1, value: 'ford', text: 'Motor Carrier' },
  { key: 2, value: 'bmw', text: 'BMW' },
])
